import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2132d3c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "module-show",
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 mt-5" }, null, -1))
const _hoisted_3 = { class: "col-md-6 mt-5" }
const _hoisted_4 = { class: "bread-crumbs mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "me-4"
}
const _hoisted_6 = {
  key: 1,
  class: "me-4"
}
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "mb-0 w-100 pe-2" }
const _hoisted_9 = { class: "float-end mb-3" }
const _hoisted_10 = { class: "description mb-0" }
const _hoisted_11 = { class: "d-flex mt-2" }
const _hoisted_12 = {
  key: 0,
  class: "deadline d-flex me-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title me-1" }, "Deadline", -1))
const _hoisted_14 = {
  key: 0,
  class: "data"
}
const _hoisted_15 = {
  key: 1,
  class: "data"
}
const _hoisted_16 = { class: "d-flex me-3" }
const _hoisted_17 = { class: "nav-wrapper" }
const _hoisted_18 = { class: "nav nav-tabs" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = {
  key: 0,
  class: ""
}
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_WYSIWYGEditor = _resolveComponent("WYSIWYGEditor")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AvatarsRow = _resolveComponent("AvatarsRow")!
  const _component_user_selection = _resolveComponent("user-selection")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_DeleteModuleModal = _resolveComponent("DeleteModuleModal")!
  const _component_CloneModuleModal = _resolveComponent("CloneModuleModal")!
  const _component_FormEditorModal = _resolveComponent("FormEditorModal")!
  const _component_task_sidebar = _resolveComponent("task-sidebar")!
  const _component_ModuleDoneWithTasksModal = _resolveComponent("ModuleDoneWithTasksModal")!
  const _component_SelectTaskTypeModal = _resolveComponent("SelectTaskTypeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isTemplate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.getClientName), 1))
          : _createCommentVNode("", true),
        (!_ctx.isTemplate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.getProject.name), 1))
          : _createCommentVNode("", true),
        (_ctx.isTemplate)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "me-4 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToProject && _ctx.goToProject(...args)))
            }, "Process Templates"))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: "cursor-pointer me-4",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToProcess && _ctx.goToProcess(...args)))
        }, _toDisplayString(_ctx.processName), 1),
        _createElementVNode("span", {
          class: "cursor-pointer",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToProcess && _ctx.goToProcess(...args)))
        }, _toDisplayString(_ctx.milestoneName), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h1", _hoisted_8, [
          _withDirectives(_createElementVNode("textarea", {
            class: "inline-headline-edit",
            rows: "1",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.module.title) = $event)),
            placeholder: "Module Title",
            ref: "inlineHeadline"
          }, null, 512), [
            [_vModelText, _ctx.module.title]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_context_menu, {
            class: "context-menu-update-task",
            id: "job-sidebar-context",
            links: [
                        {
                            text: 'Clone',
                            icon: 'copy',
                            bsToggle: 'modal',
                            bsTarget: '#cloneModuleModal',
                        },
                        {
                            text: 'Delete',
                            icon: 'trash-2',
                            bsToggle: 'modal',
                            bsTarget: '#deleteModuleModal',
                        },
                    ]
          })
        ])
      ]),
      _createElementVNode("p", _hoisted_10, [
        (_openBlock(), _createBlock(_component_WYSIWYGEditor, {
          content: _ctx.module.description,
          "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.module.description) = $event)),
          key: _ctx.module.moduleId,
          class: "mb-2",
          placeholder: "Develop an algorithm for accurate image segmentation, separating objects from backgrounds."
        }, null, 8, ["content"]))
      ]),
      _createElementVNode("div", _hoisted_11, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              (_ctx.minDuration)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.minDuration), 1))
                : _createCommentVNode("", true),
              (!_ctx.minDuration)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "..."))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", _hoisted_19, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  "active-class": "active",
                  to: "tasks",
                  type: "button",
                  role: "tab",
                  "aria-controls": "tasks",
                  "aria-selected": "false",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Tasks "),
                    (_ctx.getTaskStats.totalTasks)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.getTaskStats.completedTasks) + "/" + _toDisplayString(_ctx.getTaskStats.totalTasks), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_21, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  "active-class": "active",
                  to: "context",
                  type: "button",
                  role: "tab",
                  "aria-controls": "context",
                  "aria-selected": "false",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Context ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_22, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  "active-class": "active",
                  to: "activity",
                  type: "button",
                  role: "tab",
                  "aria-controls": "context",
                  "aria-selected": "false",
                  exact: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Activity ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createVNode(_component_user_selection, {
            selectedUsers: _ctx.computedParticipants,
            "onUpdate:selectedUsers": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.computedParticipants) = $event)),
            label: "Module Participants",
            exactlyOne: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AvatarsRow, {
                users: _ctx.computedParticipants,
                middleAvatarSize: true
              }, null, 8, ["users"])
            ]),
            _: 1
          }, 8, ["selectedUsers"]),
          _createVNode(_component_feather_icon, {
            type: 'check-circle',
            class: "ms-3 cursor-pointer",
            size: "25",
            stroke: _ctx.module.done ? '#2eb868' : '#9ea8b7',
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
            "data-bs-toggle": "modal",
            "data-bs-target": "#moduleDoneWithTasks"
          }, null, 8, ["stroke"])
        ])
      ]),
      _hoisted_23,
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_DeleteModuleModal, { module: _ctx.module }, null, 8, ["module"]),
    _createVNode(_component_CloneModuleModal, { module: _ctx.module }, null, 8, ["module"]),
    _createVNode(_component_FormEditorModal, { onHidden: _ctx.handleModalHidden }, null, 8, ["onHidden"]),
    _createVNode(_component_task_sidebar, { renderKey: _ctx.renderKey }, null, 8, ["renderKey"]),
    _createVNode(_component_ModuleDoneWithTasksModal, {
      module: _ctx.module,
      onSubmitted: _ctx.toggleModuleDone
    }, null, 8, ["module", "onSubmitted"]),
    _createVNode(_component_SelectTaskTypeModal)
  ]))
}